import { createAction, props } from '@ngrx/store';
import {
  SigIdCalculationRead,
  SigIdPayerServiceListItem,
  SigIdPaymentRead
} from '../../services/sig-id.common.model';

export const loadPayerServices = createAction('[My bills] load payer services', props<{ force?: boolean }>());

export const loadPayerServicesSuccess = createAction('[My bills] load payer services success', props<{
  services: SigIdPayerServiceListItem[]
}>());

export const loadPayerServicesFailure = createAction('[My bills] load payer services failure');

export const loadPayment = createAction('[My bills] load payment', props<{
  identSigId: string;
  serviceCode: string;
  idZap?: string;
}>());

export const loadPaymentSuccess = createAction('[My bills] load payment success', props<{
    payment: SigIdPaymentRead
  }>()
);

export const loadPaymentFailure = createAction('[My bills] load payment failure');

export const loadCalculation = createAction('[My bills] load calculation', props<{
  identSigId: string;
  serviceCode: string
}>());

export const loadCalculationSuccess = createAction('[My bills] load calculation success', props<{
  calculation: SigIdCalculationRead
}>());

export const loadCalculationFailure = createAction('[My bills] load calculation failure');
